import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left side: Logo */}
        <div className="footer-logo">
          <img 
            src="/footer.png" // replace with your actual logo path
            alt="Logo" 
            className="footer-logo-img"
          />
        </div>

        {/* Right side: Text lines and button */}
        <div className="footer-content">
          <div className="footer-text">
            <p>We don't store any media.</p>
            <p>All content is hosted by third parties.</p>
          </div>
        </div>
      </div>

      {/* Extra centered line below */}
      <div className="footer-bottom">
        <p><strong>© 2026, Stream4 City.</strong> Your cozy movie spot</p>
        
      </div>
    </footer>
  );
};

export default Footer;